import {LandIconInfoMarketTile} from '#/components/market-data/land-icon-info-market-tile';
import {TrendingLandsMarketItems} from '#/components/market-data/trending-lands-market-items';
import {ComponentProps, FunctionComponent} from 'react';
import {useQueryParam} from 'use-query-params';

type TrendingLandsEmbedQueryParams = Partial<
  Pick<ComponentProps<typeof LandIconInfoMarketTile>, 'thumbnailMode' | 'range'>
>;

export const TrendingLandsEmbed: FunctionComponent = () => {
  const [thumbnailMode = 'image'] = useQueryParam<TrendingLandsEmbedQueryParams['thumbnailMode']>('thumbnailMode');
  const [range = 'monthly'] = useQueryParam<TrendingLandsEmbedQueryParams['range']>('range');

  return (
    <TrendingLandsMarketItems
      ItemComponent={LandIconInfoMarketTile}
      itemComponentProps={{
        thumbnailMode,
        range,
      }}
    />
  );
};
